import { ADD_DATA, SET_DATA } from "services/redux/action-types";
import { dataConstants } from "services/redux/data/constants";
import _ from "lodash";
import i18n from "utils/i18n";
import { bookingConstants } from "utils/constants/booking-constants";
import { removeCartTimeslots } from 'services/redux/cart/actions'
import { collectTimeslotCapacity } from 'utils/timeslot-capacity'
import { createAlerts } from 'utils/create-alerts'
import { createDateHelper, dateFormat } from 'utils/date-helper'

const dataMiddleware = store => {
	return (
		next => {
			return (
				action => {
					switch( action.type ) {
						case SET_DATA:
							switch( action.key ) {
								case dataConstants.EMPLOYEE:
									const employeeLanguage = _.get( action.payload, ['language', 'code'], null );
									if( employeeLanguage !== null ) {
										i18n.changeLanguage( employeeLanguage );
									}
									break;

								case dataConstants.FETCHES:
									if( !_.isArray( action.payload ) ) {
										action = { ...action, payload: [ action.payload ] };
									}

									const fetches = { ...store.getState().data[ action.key ] };
									_.forEach( action.payload, name => {
										// Check if object
										let isFetching = false;
										if( _.isObject( name ) ) {
											isFetching = Object.values( name )[0];
											name = Object.keys( name )[0];
										}

										if( !_.has( fetches, name ) || isFetching === true ) {
											fetches[ name ] = isFetching;
										}
									});

									action = { ...action, payload: fetches };
									break;
							}

							return next( action );

						case ADD_DATA:
							const employee = store.getState().data[ dataConstants.EMPLOYEE ];
							const employeeGuid = _.get( employee, 'guid', null );

							switch( action.key ) {
								case dataConstants.BOOKINGS:
									const payload = {};
									if( !_.isEmpty( employeeGuid ) ) {
										_.forEach( action.payload, ( booking, key ) => {

											const bookingEmployeeGuid = _.get( booking, ['employee', 'guid'], null );

											// Is the employee booking found? Only then continue with this
											if( !_.isEmpty( bookingEmployeeGuid ) ) {
												if( bookingEmployeeGuid === employeeGuid ) {
													payload[ key ] = booking;
												}
											} else {
												// When the key is already in the bookings, then we also may update
												const bookings = store.getState().data[ action.key ];

												if( _.has( bookings, key ) ) {
													payload[ key ] = booking;
												}
											}
										});
									}

									action = { ...action, payload };
									break;

								case dataConstants.TIMESLOTS_OCCUPIED:
									// Get the cart
									const cartTimeslots = store.getState().cart?.timeslots ?? {};
									const bookings = store.getState().data?.[ dataConstants.BOOKINGS ];

									// Go through the results
									let showWarning = false;
									_.forEach( action.payload, ( timeslotCapacity, itemKey) => {

										// Check the cart items
										const cartItem = cartTimeslots?.[ itemKey ];

										// Found cardItem?
										if( cartItem !== undefined ) {
											const kind = ( cartItem.kind === bookingConstants.MEETING_ROOM ) ? bookingConstants.BOOKING : cartItem.kind;
											const isMeetingRoom = cartItem.kind === bookingConstants.MEETING_ROOM;

											// Check if there are enough places available
											const { enoughPlacesAvailable, isTimeslotBooked } = collectTimeslotCapacity( cartItem, timeslotCapacity, store.getState().cart );

											const timeslotCapacityBooking = _.find( bookings, ( booking ) => {
												// Check if the booking is for the same timeslot
												const isSameTimeslot = booking?.timeslot?.guid === timeslotCapacity?.timeslot_guid;

												// Check if the booking is for the same date
												const isSameDate = booking?.booking_date === timeslotCapacity?.date;

												return isSameTimeslot && isSameDate;
											})

											// Removing is default no
											let hasToRemoveFromCart = false;

											// Check if it is a meeting room
											if( isMeetingRoom ) {
												// Is the timeslot already booked?
												// Then we have to remove it
												if( isTimeslotBooked ) {
													hasToRemoveFromCart = true;
												}

											// Not a meeting room?
											} else {
												// Nog enough space available?
												if( !enoughPlacesAvailable ) {
													hasToRemoveFromCart = true;
												}
											}

											// If there are not enough places available it has to be removed from the cart
											if( hasToRemoveFromCart ) {

												if( !timeslotCapacityBooking ) {
													// Set the date
													//// When it is not US!
													showWarning = cartItem.booking_date;

													// When selected, remove :)
													store.dispatch( removeCartTimeslots( itemKey ) );
												}
											}
										}
									})

									// The warning contains the date
									if( showWarning !== false ) {
										// Create a alert
										createAlerts( store.dispatch ).alert(
											i18n.t( 'page.create.alert_booking_occupied.title' ),
											i18n.t( 'page.create.alert_booking_occupied.description', {
												date: createDateHelper( store.getState ).date( showWarning, dateFormat.DATE ).format( dateFormat.DATE_PRETTY )
											})
										);
									}
									break;
							}

							return next( action );

						default:
							return next(action);
					}
				}
			);
		}
	);
};

export default dataMiddleware;
